var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#07575B","strokeLinecap":"square","strokeWidth":"1.5","d":"M9.243 5L5 9.243.757 5"}));
}

ArrowDown.defaultProps = {"width":"15","height":"15","viewBox":"0 0 10 10"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
